<ng-template #showModalLogin let-modal>

    <div class="modal-header">
        <div class="modal-title">Log In</div>
        <button type="button" class="close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">

        <form class="form-horizontal" [formGroup]="loginForm" (ngSubmit)="onLoginSubmit()" #formDir="ngForm">
            <!-- username -->
            <div class="form-group" [ngClass]="{'has-danger': invalidUsername}">
                <label class="font-l1">Email</label>
                <input class="form-control" type="email" placeholder="Email" formControlName="username">
                <div class="form-control-feedback" *ngIf="invalidUsername">
                    <small *ngIf="username.errors?.email">
                        El email debe ser válido
                    </small>
                    <small *ngIf="username.errors?.required">
                        El email es requerido
                    </small>
                </div>
            </div>

            <!-- password -->
            <div class="form-group m-b-1" [ngClass]="{'has-danger': invalidPassword}">
                <label class="font-l1">Contraseña</label>
                <input class="form-control" type="password" placeholder="Contraseña" formControlName="password">
                <small class="form-control-feedback" *ngIf="invalidPassword">
                    La contraseña es requerida
                </small>
            </div>

            <!-- errorMsg -->
            <div class="form-group has-danger" *ngIf="errorMsg">
                <small class="form-control-feedback">
                    {{errorMsg}}
                </small>
            </div>

            <!-- button submit -->
            <div class="form-group text-center m-t-20">
                <button class="btn btn-primary" type="submit" [disabled]="loginForm.invalid">Iniciar sesión</button>
            </div>
        </form>

    </div>
</ng-template>
